import script from "./MessagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagePage.vue?vue&type=script&setup=true&lang=js"

import "./MessagePage.vue?vue&type=style&index=0&id=01d0327c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d0327c"]])

export default __exports__